import { Brand } from '@components/ui/Brand';
import { Grid, Stack, styled, Typography, useMediaQuery, Theme } from '@mui/material';
import { LoginLangDropdown } from 'components/login/LoginLangDropdown';
import dynamic from 'next/dynamic';
import React, { FC } from 'react';

import { LoginForm } from './LoginForm';

import config from '@/config';

const PageDefault = dynamic(() => import('@components/ui/Page/PageDefault'));

const LoginViewHead = styled(Grid, {
  name: 'LoginView',
  slot: 'Head',
})({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
});

interface LoginViewProps {
  manager?: boolean;
}

const LoginView: FC<LoginViewProps> = ({ manager = false }) => {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  return (
    <Stack direction="row" flexGrow={1}>
      <Stack
        direction="column"
        justifyContent="space-between"
        sx={{
          flexGrow: 0,
          flexBasis: 375,
          p: 5,
          pb: 3,
          bgcolor: 'background.paper',
          ...(isMobile && {
            flexBasis: '100%',
          }),
        }}
      >
        <LoginViewHead container>
          <Brand />
          <LoginLangDropdown manager={manager} />
        </LoginViewHead>

        <Stack direction="column" flexGrow={1} justifyContent="center">
          <LoginForm manager={manager} />
        </Stack>

        <Stack
          direction="row"
          alignItems="center"
          alignSelf="stretch"
          justifyContent="space-between"
        >
          <Typography variant="caption" sx={{ fontWeight: 500 }}>
            © {new Date().getFullYear()} MAYORAL MODA INFANTIL S.A.U.
          </Typography>

          <Typography variant="caption" sx={{ fontWeight: 500, color: 'grey.600' }}>
            v{config.public.version}
          </Typography>
        </Stack>
      </Stack>
      <PageDefault />
    </Stack>
  );
};

export default LoginView;
